import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import { connect } from 'react-redux'
import * as actions from '../../store/actions'
import WyborStrukturyStyle from '../../styles/WyborStrukturyStyle'
import WyborStrukturyRowStyle from '../../styles/WyborStrukturyRowStyle'
import NazwaStruktury from '../NazwaStruktury'
import { getKodBazowy } from '../../lib/kodSystemowy'

const getKodSprawozdania = kod => {
  const kodBazowy = getKodBazowy(kod)
  switch (kodBazowy) {
    case 'SFJINZ':
      return 'SprFinJednostkaInnaWZlotych'
    case 'SFJMAZ':
      return 'SprFinJednostkaMalaWZlotych'
    case 'SFJMIZ':
      return 'SprFinJednostkaMikroWZlotych'
    case 'SFJOPZ':
      return 'SprFinOpWZlotych'
    case 'SFJINT':
      return 'SprFinJednostkaInnaWTysiacach'
    case 'SFJMAT':
      return 'SprFinJednostkaMalaWTysiacach'
    case 'SFJMIT':
      return 'SprFinJednostkaMikroWTysiacach'
    case 'SFJOPT':
      return 'SprFinOpWTysiacach'
    case 'SFSINZ':
      return 'SprFinSkonsolidowanaJednostkaInnaWZlotych'
    case 'SFSINT':
      return 'SprFinSkonsolidowanaJednostkaInnaWTysiacach'
    case 'SFDMAZ':
      return 'SprFinDomMaklerskiWZlotych'
    case 'SFDMAT':
      return 'SprFinDomMaklerskiWTysiacach'
    default:
      return ''
  }
}

class WyborStruktury extends Component {
  render() {
    const { availableStructures, onSetStructure, dataSporzadzenia } = this.props
    return (
      <>
        <WyborStrukturyStyle>
          <div className="header">
            <div>
              <span className="high-headline-5">
                DOSTĘPNE STRUKTURY E-SPRAWOZDAŃ
              </span>
              {'  '}
              <span className="medium-emphasis-subtitle-2">
                (DLA DATY SPORZĄDZENIA: {dataSporzadzenia})
              </span>
            </div>
            <Button
              color="primary"
              variant="outlined"
              onClick={() => {
                onSetStructure(null, null)
              }}
            >
              WRÓĆ
            </Button>
          </div>
          <WyborStrukturyRowStyle className="container">
            {availableStructures
              ? availableStructures.map(element => (
                  <WyborStrukturyRowStyle key={element.priorytet}>
                    <main
                      data-cy="wybor-struktury"
                      className={
                        'row ' + getKodSprawozdania(element.kod.KodSystemowy)
                      }
                      onClick={() => onSetStructure(element.kod)}
                    >
                      <div className="nazwaStruktury">
                        <NazwaStruktury
                          wybor={true}
                          KodSprawozdania={getKodSprawozdania(
                            element.kod.KodSystemowy,
                          )}
                        />
                      </div>
                      <div className="code">
                        <span className="disabled-caption">KOD SYSTEMOWY</span>
                        <span className="medium-emphasis-body-2">
                          {element.kod.KodSystemowy}
                        </span>
                      </div>
                      <div className="variant">
                        <span className="disabled-caption">WARIANT</span>
                        <span className="medium-emphasis-body-2">
                          {element.kod.WariantSprawozdania ||
                            element.kod.Wariant ||
                            '-'}
                        </span>
                      </div>
                      <div className="version">
                        <span className="disabled-caption">WERSJA SCHEMY</span>
                        <span className="medium-emphasis-body-2">
                          {element.kod.WersjaSchemy}
                        </span>
                      </div>
                    </main>
                  </WyborStrukturyRowStyle>
                ))
              : null}
          </WyborStrukturyRowStyle>
        </WyborStrukturyStyle>
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    dataSporzadzenia: state.sprawozdanie.dataSporzadzenia,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSetStructure: struktura => dispatch(actions.setStructure(struktura)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WyborStruktury)
